import { useContext } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { AuthContext } from '../../context/authContext';
import { getItem, STORAGE_KEYS } from '../../services/storage';

// HOC para no permitir el acceso a ramas internas dependiendo el rol del usuario.
// Si se pasa allowedEmails, también se permite el acceso a esos emails aunque su rol
// no esté en la lista.
const PrivateRoute = ({ roles, allowedEmails, children }) => {
  const { getUserRol } = useContext(AuthContext);
  const userRol = getUserRol();
  const userSession = getItem(STORAGE_KEYS.USER);
  const userEmail = userSession?.profileObj?.email;

  const rolPermitido = !roles || roles.includes(userRol);
  const emailPermitido = allowedEmails && userEmail && allowedEmails.includes(userEmail);

  // TODO: Pendiente de incluir una página de acceso denegado (access-denied).
  // Importante: redirigimos SIN montar los hijos, para que el componente protegido
  // no dispare sus fetches cuando el rol/email no está permitido.
  if (!rolPermitido && !emailPermitido) return <Navigate to="/" replace />;

  return children;
};

PrivateRoute.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string),
  allowedEmails: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
